import { memo } from 'react'
import { isEqual } from 'lodash'
import DashboardDoctorContainer from 'app/containers/Dashboard/DashboardDoctor'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const DashboardDoctorCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.dashboard_doctor)}</PageTitle>
      <DashboardDoctorContainer />
    </>
  )
}
export const DashboardDoctorPage = memo(DashboardDoctorCpn, isEqual)
